// Libraries
import { ColumnFilterProps } from '@organisms/index';
// Types
import {
  DateRangePickerFilter,
  DateRangePickerFilterProps,
  DebounceFilterInput,
  DebounceFilterInputProps,
  DropdownFilter,
  DropdownFilterProps,
  RangeFilter,
  RangeFilterProps,
  UnitAndRangeFilter,
  UnitAndRangeFilterProps,
  RatingsButtonsFilter,
  RatingsButtonsFilterProps,
  YearPicker,
  YearPickerProps,
} from './Components';
import { FilterType } from './FilterFactory.types';

/**
 * Represents a mapping of filter types to their respective filter components.
 */
export const FilterComponentMap = {
  /**
   * Debounce Input Filter Component.
   * Renders a DebounceFilterInput component for the specified filter type.
   */
  [FilterType.DEBOUNCE_INPUT]: <TableData,>(props: ColumnFilterProps<TableData, DebounceFilterInputProps>) => (
    <DebounceFilterInput {...props} />
  ),
  /**
   * Ratings Buttons Filter Component.
   * Renders a RatingsButtonsFilter component for the specified filter type.
   */
  [FilterType.RATINGS_BUTTONS_FILTER]: <TableData,>(props: ColumnFilterProps<TableData, RatingsButtonsFilterProps>) => (
    <RatingsButtonsFilter {...props} />
  ),
  /**
   * Range Filter Component.
   * Renders a RatingsButtonsFilter component for the specified filter type.
   */
  [FilterType.RANGE_FILTER]: <TableData,>(props: ColumnFilterProps<TableData, RangeFilterProps>) => (
    <RangeFilter {...props} />
  ),
  /**
   * Unit And Range Filter Component.
   * Renders a UnitAndRangeFilter component for the specified filter type.
   */
  [FilterType.UNIT_AND_RANGE_FILTER]: <TableData,>(props: ColumnFilterProps<TableData, UnitAndRangeFilterProps>) => (
    <UnitAndRangeFilter {...props} />
  ),
  /**
   * Date Range Filter Component.
   * Renders a DateRangePickerFilter component for the specified filter type.
   */
  [FilterType.DATE_RANGE_PICKER]: <TableData,>(props: ColumnFilterProps<TableData, DateRangePickerFilterProps>) => (
    <DateRangePickerFilter {...props} />
  ),
  /**
   * Year Picker Filter Component.
   * Renders a YearPicker component for the specified filter type.
   */
  [FilterType.YEAR_PICKER]: <TableData,>(props: ColumnFilterProps<TableData, YearPickerProps>) => (
    <YearPicker {...props} />
  ),
  /**
   * Select Filter Component.
   * Renders a DropdownFilter component for the specified filter type.
   */
  [FilterType.DROPDOWN_FILTER]: <TableData,>(props: ColumnFilterProps<TableData, DropdownFilterProps>) => (
    <DropdownFilter {...props} />
  ),
};
